define([
    "dojo/_base/declare",
    "csi/heading/String"
], function(declare,StringRen) {

    return declare(StringRen, {
        
        getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
            // summary: disable filtering
            return null;
        }

    });
});